<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>翻新设备</el-breadcrumb-item>
      <el-breadcrumb-item>已售出设备</el-breadcrumb-item>
    </el-breadcrumb>
    <used-device-list :status="100"></used-device-list>
  </div>
</template>

<script>
import UsedDeviceList from './list'
export default {
  components: { UsedDeviceList },
}
</script>